"use strict";
/*
 * Membrane React package
 * {@link https://www.npmjs.com/package/@membranehq/react}
 * v0.29.2
 */
'use client';

import { jsx } from 'react/jsx-runtime';
import { withSlotScopeClasses } from '../../../helpers/scoped-slots.mjs';
import { forwardRef } from 'react';
import { tv } from 'tailwind-variants';

const fieldControlPanelRecipe = tv({
  slots: withSlotScopeClasses("field-control-panel", {
    root: "max-w-full flex items-center justify-start flex-row flex-wrap gap-x-2 gap-y-1",
    delimiter: "text-fg-subtle font-medium",
    group: "flex flex-row flex-nowrap overflow-hidden max-w-full",
    button: [
      "appearance-none cursor-pointer align-middle",
      "max-w-full flex items-center justify-center gap-2",
      "transition-all duration-200",
      "bg-bg-subtle text-fg-subtle border border-border-subtle rounded-[0.625rem] font-medium",
      "m-0 py-1 px-2.5",
      "hover:bg-bg-muted hover:border-border-muted hover:text-fg-muted",
      "disabled:text-fg-disabled disabled:cursor-not-allowed",
      "[&_svg]:h-3 [&_svg]:w-3 [&_svg]:shrink-0 [&_svg]:grow-0 [&_svg]:stroke-[0.125rem]",
      "[[data-fc-group='true']_&]:rounded-none",
      "[[data-fc-group='true']_&:not(:first-child)]:border-l-0",
      "[[data-fc-group='true']_&:first-child]:rounded-l-[0.625rem]",
      "[[data-fc-group='true']_&:last-child]:rounded-r-[0.625rem]"
    ]
  }),
  variants: {
    noWrap: {
      true: { root: "flex-nowrap" }
    }
  }
});
function FieldControlPanelRoot({ children, noWrap }) {
  const styles = fieldControlPanelRecipe({ noWrap });
  return /* @__PURE__ */ jsx("div", { className: styles.root(), children });
}
function FieldControlPanelDelimiter({ children }) {
  const styles = fieldControlPanelRecipe();
  return /* @__PURE__ */ jsx("span", { className: styles.delimiter(), children });
}
function FieldControlButtonGroup({ children }) {
  const styles = fieldControlPanelRecipe();
  return /* @__PURE__ */ jsx("div", { className: styles.group(), "data-fc-group": "true", children });
}
const FieldControlButtonElement = forwardRef(({ children, className, ...props }, ref) => {
  const styles = fieldControlPanelRecipe();
  return /* @__PURE__ */ jsx("button", { ref, className: styles.button({ className }), ...props, children });
});
const FieldControlPanel = Object.assign(FieldControlPanelRoot, {
  Delimiter: FieldControlPanelDelimiter,
  ButtonGroup: FieldControlButtonGroup,
  Button: FieldControlButtonElement
});

export { FieldControlPanel };
